import React from "react";
import { useSelector } from "react-redux";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";
import { PatientProfileForm } from "features/patients/components/PatientProfileForm/PatientProfileForm";
import { useUpdatePatient } from "features/patients/hooks/useUpdatePatient";

// The Save button lives in the Dialog footer, outside PatientProfileForm's
// <form>, so it's associated to the form by id (form="...") to submit it.
const EDIT_PATIENT_FORM_ID = "edit-patient-form";

const EditPatientModal = ({ patient, isOpen, onClose, onSuccess }) => {
  let tenantVal = useSelector((state) => state.auth.user?.tenant);
  if (!tenantVal) tenantVal = localStorage.getItem("kinesin-tenant");

  const updatePatient = useUpdatePatient(patient?.id);

  const handleFormSubmit = (formData) => {
    const patientCopy = patient || {};
    const tenantNumber =
      typeof tenantVal === "string" ? parseInt(tenantVal, 10) : tenantVal;
    const patientData = {
      ...patientCopy,
      ...formData,
      address: {
        id: patientCopy.address?.id,
        tenant: patientCopy.address?.tenant || tenantNumber,
        addressLine1: formData.addressLine1 || "",
        addressLine2: formData.addressLine2 || "",
        addressLine3: formData.addressLine3 || "",
        city: formData.city || "",
        county: formData.county || "",
        postCode: formData.postCode || "",
        country: formData.country ?? "",
      },
      addressId: patientCopy.address?.id,
    };

    updatePatient.mutate(patientData, {
      onSuccess: () => {
        onClose();
        onSuccess?.();
      },
    });
  };

  return (
    <Dialog
      open={isOpen && !!patient}
      onClose={onClose}
      title="Edit patient"
      width={1200}
    >
      <PatientProfileForm
        patient={patient}
        onSubmit={handleFormSubmit}
        formId={EDIT_PATIENT_FORM_ID}
        hideSubmitButton
      />
      <DialogFooter>
        <Button variant="outline" size="large" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="submit"
          form={EDIT_PATIENT_FORM_ID}
          variant="primary"
          size="large"
          disabled={updatePatient.isPending}
        >
          {updatePatient.isPending ? "Saving..." : "Save"}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export { EditPatientModal };
